import { createFileRoute } from '@tanstack/react-router'
import {
  InteractionChannel,
  QueueStatus,
  CallIn,
  CallOut,
} from '@/components/monitors-route/daily-stats'
import { getUser } from '@/utils/auth'
import {
  getDailyChannelStat,
  getDailyCallStat,
  getTotalEmailInQueue,
} from '@/api/monitor'
import { useQuery } from '@tanstack/react-query'
import { throwException } from '@/exceptions/throw-exception.js'
import QUERY_KEY from '@/constants/use-query-key.js'

export const Route = createFileRoute('/_auth/monitors/daily-stats')({
  component: Activity,
})

function Activity() {
  const user = getUser()

  const { isLoading: isLoadingCallStat, data: dailyCallStat } = useQuery({
    queryKey: [QUERY_KEY.GET_DAILY_CALL_STAT],
    queryFn: async () => {
      const resp = await getDailyCallStat(user.tenant_id)
      return resp?.data || {}
    },
    initialData: {},
    refetchInterval: 5000,
  })

  const { isLoading: isLoadingChannelStat, data: channelStat } = useQuery({
    queryKey: [QUERY_KEY.GET_DAILY_CHANNEL_STAT],
    queryFn: async () => {
      const resp = await getDailyChannelStat()
      return resp?.data?.analytic || {}
    },
    initialData: {},
    refetchInterval: 5000,
  })

  const { isLoading: isLoadingTotalEmailQueue, data: totalEmailInQueue } =
    useQuery({
      queryKey: [QUERY_KEY.GET_TOTAL_EMAIL_IN_QUEUE],
      queryFn: async () => {
        const resp = await getTotalEmailInQueue(user.tenant_id)
        return resp?.data || 0
      },
      initialData: 0,
      refetchInterval: 5000,
    })
  const totalChatQueue =
    (channelStat?.totalFacebookWaiting || 0) +
    (channelStat?.totalZaloWaiting || 0) +
    (channelStat?.totalChatWaiting || 0)

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="col-span-1 grid grid-cols-1 gap-4">
        <InteractionChannel
          facebook={channelStat?.totalFacebook}
          email={totalEmailInQueue || channelStat?.totalEmail}
          livechat={channelStat?.totalChat}
          zalo={channelStat?.totalZalo}
          isLoading={isLoadingChannelStat}
        />
        <CallIn
          total={dailyCallStat?.call_in}
          answer={dailyCallStat?.answer_call_in}
          miss={dailyCallStat?.miss_call_in}
          reject={dailyCallStat?.reject_call_in}
          avg_answer={dailyCallStat?.average_time_answer_in}
          avg_waiting={dailyCallStat?.average_time_waiting_in}
          isLoading={isLoadingCallStat}
        />
      </div>
      <div className="col-span-1 grid grid-cols-1 gap-4">
        <QueueStatus
          chat={totalChatQueue + (totalEmailInQueue || 0)}
          call={0}
          isLoading={isLoadingChannelStat || isLoadingTotalEmailQueue}
        />
        <CallOut
          total={dailyCallStat?.call_out}
          answer={dailyCallStat?.answer_call_out}
          miss={dailyCallStat?.miss_call_out}
          reject={dailyCallStat?.reject_call_out}
          avg_answer={dailyCallStat?.average_time_answer_out}
          avg_waiting={dailyCallStat?.average_time_waiting_out}
          miss_predictive={dailyCallStat?.miss_call_out_prd}
          avg_waiting_miss_predictive={
            dailyCallStat?.average_time_waiting_out_prd
          }
          isLoading={isLoadingCallStat}
        />
      </div>
    </div>
  )
}
